export default "__VITE_ASSET__DlwUP3yE__"